var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-container"},[_c('div',{staticClass:"nosto_page_type",staticStyle:{"display":"none"}},[_vm._v("\n    other\n  ")]),_vm._v(" "),_c('div',{attrs:{"id":"talkable-offer"}})])
}]

export { render, staticRenderFns }